import { createSlice } from '@reduxjs/toolkit';

import { PlanState, SetCollectionsPayload, SetResourcesPayload } from './plan.types';

export const initialState: PlanState = {
  collections: [],
  resources: []
};

const PlanSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    setCollections: (state, action: SetCollectionsPayload) => {
      state.collections = action.payload;
    },
    setResources: (state, action: SetResourcesPayload) => {
      state.resources = action.payload;
    }
  }
});

export const { setCollections, setResources } = PlanSlice.actions;

export default PlanSlice.reducer;
